/**
 * Defines jQuery plugin `animateGroup`
 * that waits for all `img.animation-layer` elements to trigger their "load" events
 * and then removes a class `animation-pending`
 * allowing any transitions that are defined by CSS to take effect without that class.
 */
(($) => {

    $.fn.animateGroup = function () {

        const animationGroups = this;

        animationGroups.each((i, el) => {
            const animationGroup = $(el);
            const animationLayers = animationGroup.find('img.animation-layer');
            const numLayers = animationLayers.length;
            let numLayersLoaded = 0;
            const loadLayer = () => {
                numLayersLoaded++;
                if (numLayersLoaded === numLayers) {
                    setTimeout(() => {
                        animationGroup.removeClass('animation-pending');
                    }, 1000);
                }
            };
            animationLayers.each((i, img) => {
                if (img.complete) {
                    loadLayer();
                }
                else {
                    img.onload = loadLayer;
                    img.onerror = loadLayer;
                }
            });

        });

    };

})(jQuery);
